
<template>
  <div class="header-logged-in">
    <div><img style="max-width:5em; max-height: 100%;" src="../assets/Orbita-2-Logo.jpg" alt="Orbita-2 Logo"></div>
    <div>
      <div v-if="name">{{name}}</div>
      <div v-else-if="email">{{email}}</div>
      <div v-if="trialId">{{trialId}}</div>
      <div v-if="privileges && privileges.blindedResearcher" class="little">Blinded Staff</div>
      <div v-if="privileges && privileges.unblindedResearcher" class="little">Unblinded Staff</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: false
    },
    email: { type: String, required: false },
    trialId: { type: String, required: false },
    privileges: { type: Object, required: false }
  }
};
</script>

<style>
.little {
  font-size: 71%;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderBand.vue